<div class="sk-lap">
  <div class="sk-fej">
    <img [src]="ikon" alt="">
    <div><h1>{{ inv.aktiv.ugyfelNev || 'Készletkezelés' }}</h1>
      <p>Készletkezelés (Inventario){{ inv.aktiv.szerep === 'konyvelo' ? ' – könyvelői nézet, csak olvasás' : '' }}.</p></div>
  </div>
  <div class="sk-ossz" *ngIf="ossz">
    <div><span>Cikkek</span><b>{{ ossz.cikk }} db</b></div>
    <div><span>Készletérték (átlagáron)</span><b>{{ szam(ossz.ertek) }} Ft</b></div>
    <div [class.rossz]="ossz.hiany"><span>Minimum alatt</span><b>{{ ossz.hiany }} cikk</b></div>
    <div><span>Mozgás e hónapban</span><b>{{ ossz.mozgas }} db</b></div>
  </div>
  <div class="sk-racs">
    <button type="button" class="sk-csempe kesz" *ngFor="let c of csempek" (click)="nyit(c)">
      <ion-icon [name]="c.ikon"></ion-icon><div class="sk-szoveg"><b>{{ c.cim }}</b><span>{{ c.leiras }}</span></div>
    </button>
  </div>
</div>
